import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { TransactionTypeString, transactionTypeCharMap } from '@tassat/common-definitions';
import { TransactionHistoryRecord } from '@tassat/fred-extended-definitions';
import React from 'react';

interface ClientCounterpartyWalletCellRendererProps {
    data: TransactionHistoryRecord;
}

const muiStyles = makeStyles({
    root: { height: '100%' },
    name: { lineHeight: '20px' }
});

const ClientCounterpartyWalletCellRenderer = (props: ClientCounterpartyWalletCellRendererProps) => {
    const { data } = props;

    const tranType: string = (transactionTypeCharMap(data.type as any) as string);
    let counterpartyIsSender = true;

    if (
        tranType === TransactionTypeString.send ||
        tranType === TransactionTypeString.order
    ) {
        counterpartyIsSender = false;
    }

    const classes = muiStyles(props);

    return (
        <Grid
            className={classes.root}
            container
            direction='column'
            justifyContent='center'
            spacing={0}
        >
            <span className={classes.name}>{counterpartyIsSender ? data.SenderAccountName : data.RecipientAccountName}</span>
        </Grid>
    );
};

export default ClientCounterpartyWalletCellRenderer;